import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';

// Shared "← back" control for the login/MFA flow. Anchored top-left (not under
// the primary button) so on mobile it never sits next to the CTA, where a
// mis-tap is easy.
export default function BackLink({ onClick, label, disabled = false }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="mb-4 flex cursor-pointer items-center gap-1.5 self-start border-0 bg-transparent p-1 pl-0 font-sans text-[10.5px] font-semibold uppercase tracking-[0.1em] text-muted transition-colors hover:text-accent disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:text-muted">
      <IconComponent iconName="arrow-back" style={{ fontSize: 14 }} />
      {label || t('heimdal_app.TOTP.back')}
    </button>
  );
}

BackLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};
